import React from 'react';
import { Grid, Box } from '@mui/material';
import Intro from './Intro';
import { ResearchAssistance as RA } from './ResearchAssistance';

export default function ResearchAssistance() {
    return (
        <Box>
            <Grid container>
                <Intro />
                <RA />
            </Grid>
        </Box>
    )
}